export * from './dateformat.pipe';
export * from './filter.pipe';
export * from './phone.pipe';
export * from './safehtml.pipe';
export * from './format.pipe';


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/pipes/index.ts